module.exports = __webpack_public_path__ + "static/media/13.8e886b1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/13.jpg
// module id = 382
// module chunks = 0